import { styled } from '@mui/material';

import { ChkViewContainer } from '@ui/checkout-components';

import type { WrapperProps } from './Wrapper.types';

export function Wrapper({ children, ...props }: WrapperProps) {
  return (
    <ChkViewContainer {...props}>
      <ContentContainer>{children}</ContentContainer>
    </ChkViewContainer>
  );
}

const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(7),
}));
